import { Component, input } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-coins-template-info',
  imports: [TranslatePipe],
  templateUrl: './coins-template-info.component.html',
  styleUrls: [
    './coins-template-info.component.scss',
    '../template-shared.stylesheet.scss',
  ],
})
export class CoinsTemplateInfoComponent {
  translationPrefix = input('', { transform: appendPrefix });
}
function appendPrefix(value: string | undefined): string {
  return value + 'coin.';
}
